module.exports = __webpack_public_path__ + "static/banner-9a7fd0b1de3a014934e67d4d0896bcfa.jpg";